<template>
  <CCard>
    <CCardBody>
      <h5 class="text-primary">Country Specific Application Count</h5>
      <div class="w-100 d-flex justify-content-center align-items-center">
        <!-- <GeoChartKSA v-if="data.length"
          :candidates="data"
        /> -->
        <iframe
          src="/map/applicationMap.html"
          width="1366"
          height="550"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import GeoChartKSA from "./GeoChartKSA.vue";
export default {
  name: "CountrySpecificChart",
  components: {
    GeoChartKSA,
  },
  computed: {
    data() {
      const res = [
        {
          country: "canada",
          count: 501,
        },
        {
          country: "germany",
          count: 487,
        },
        {
          country: "new zealand",
          count: 506,
        },
        {
          country: "london",
          count: 516,
        },
        {
          country: "ireland",
          count: 471,
        },
        {
          country: "sweden",
          count: 521,
        },
        {
          country: "united states",
          count: 495,
        },
        {
          country: "australia",
          count: 503,
        },
      ];

      return res;
    },
  },
};
</script>

<style scoped>
h4 {
  text-align: center;
}
</style>
